import { render } from "./PaymentSMS.vue?vue&type=template&id=70a1022f&scoped=true&ts=true"
import script from "./PaymentSMS.vue?vue&type=script&lang=ts"
export * from "./PaymentSMS.vue?vue&type=script&lang=ts"

import "./PaymentSMS.vue?vue&type=style&index=0&id=70a1022f&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70a1022f"]])

export default __exports__